import * as ol from 'openlayers';
import {ChannelMarker} from './channel-marker';

export class HighlightedChannelMarker extends ol.Feature {
  public static readonly SCALE = 0.25;
  public static readonly TYPE_WALL = 'WALL';
  public static readonly TYPE_FLOOR = 'FLOOR';
  public static readonly TYPE_CEILING = 'CEILING';

  static readonly HighlightedWallChannelMarker = new ol.style.Style({
    image: new ol.style.Icon(({
      anchor: [0.5, 32.0],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 1.0,
      scale: ChannelMarker.SCALE,
      src: './assets/images/drawing/highlighted-wall-channel.png'
    }))
  });

  static readonly HighlightedFloorCeilingMarker = new ol.style.Style({
    image: new ol.style.Icon(({
      anchor: [0.5, 32.0],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      opacity: 1.0,
      scale: ChannelMarker.SCALE,
      src: './assets/images/drawing/highlighted-floor-ceiling-channel.png'
    }))
  });

  public label: string;
  public x: any;
  public y: any;

  constructor(x = 0, y = 0, location: string, coordinateScale: number = 1.0) {
    super({
      geometry: new ol.geom.Point([x * coordinateScale, y * coordinateScale]),
      type: 'Point'
    });

    switch(location) {
      case HighlightedChannelMarker.TYPE_CEILING:
      case HighlightedChannelMarker.TYPE_FLOOR: {
        this.setStyle(HighlightedChannelMarker.HighlightedFloorCeilingMarker);
      } break;

      case HighlightedChannelMarker.TYPE_WALL: {
        this.setStyle(HighlightedChannelMarker.HighlightedWallChannelMarker);
      } break;

      default: {
        this.setStyle(HighlightedChannelMarker.HighlightedWallChannelMarker);
      } break;
    }


    this.x = x;
    this.y = y;
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/drawing/highlighted-channel-marker.ts